import React from "react"
import styled from "styled-components"

const Styled = styled.p`
    font-size: ${props => props.size};
`

const Text = ({size = "18px", children}) => {
    return <Styled size={size}>{children}</Styled>
}

export default Text
